import { InfoActionBanner as InfoActionBannerUI } from '@pixum/info-action-banner';
import type { InfoActionBannerNode, LinkNode } from 'data-layer';
import type { DeviceOrientedComponentProps } from '../../types';
import { Image, IMAGE_LOADING } from '../image';
import { ButtonCollection } from '../buttonCollection';
import { CountdownWrapper } from '../countdown';
import { CREATIVE_ID } from 'hooks';

export type InfoActionBannerProps = InfoActionBannerNode & DeviceOrientedComponentProps;

export function InfoActionBanner(props: InfoActionBannerProps) {
  const { heading, subline, image, countdown, device, links, hasLinks } = props;

  const media = image ? <Image device={device} image={image} loading={IMAGE_LOADING.LAZY} /> : undefined;
  const countdownEl = countdown ? <CountdownWrapper countdown={countdown} /> : undefined;
  const ctaEl =
    hasLinks && links ? (
      <ButtonCollection buttons={links as LinkNode[]} device={device} creativeId={CREATIVE_ID.CONTENT} />
    ) : undefined;

  return (
    <div className="info-action-banner__container center--content">
      <InfoActionBannerUI media={media} heading={heading} subline={subline} countdown={countdownEl} cta={ctaEl} />
    </div>
  );
}
